<div class="SendToCampaign" *ngIf="componentReady">
  <div class="container" [formGroup]="inputForm">
    <div class="row">
      <div class="col-6 d-flex align-items-center">Select campaign:</div>
      <div class="col-6">
        <app-select
          [items]="getCampaignsSelectItems()"
          label="Campaign"
          formControlName="campaign_id"></app-select>
        <mat-error
          *ngIf="(campaignId.touched || campaignId.dirty) && campaignId.errors">
          <span *ngIf="campaignId.errors?.required" class="text-danger"
            >Please, select a campaign</span
          >
        </mat-error>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-6 d-flex align-items-center">Select start date</div>
      <div class="col-6">
        <app-text-field
          [datePickerStartDate]="getStartDate()"
          type="date"
          formControlName="start_date"
          placeholder="Start Date"
          datePickerType="calendar"></app-text-field>
        <mat-error
          *ngIf="(startDate.touched || startDate.dirty) && startDate.errors">
          <span *ngIf="startDate.errors?.required" class="text-danger"
            >Please, select a campaign</span
          >
        </mat-error>
      </div>
    </div>
  </div>
</div>
